import { render, staticRenderFns } from "./createClaim.vue?vue&type=template&id=7d04f9d8&scoped=true"
import script from "./createClaim.vue?vue&type=script&lang=js"
export * from "./createClaim.vue?vue&type=script&lang=js"
import style0 from "./createClaim.vue?vue&type=style&index=0&id=7d04f9d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d04f9d8",
  null
  
)

export default component.exports